import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PowerSettingsNewIcon(props: IconProps) {
    return <Icon {...props} iconKey={"power_settings_new"}/>
}
